import { ChangeEvent, useEffect, useState } from "react";
import "../App.css";

interface IProps {
  startPage: number;
  endPage: number;
  totalPages: number;
  colourMode: string;
  onRowChanged: (
    startPage: number,
    endPage: number,
    colourMode: string,
  ) => void;
}

function MixModePagesRowSelector({
  startPage,
  endPage,
  totalPages,
  colourMode,
  onRowChanged,
}: IProps) {
  const [inputEndPage, setInputEndPage] = useState(totalPages);
  useEffect(() => {
    setInputEndPage(endPage);
  }, [endPage]);

  function handleEndChanged(event: ChangeEvent<HTMLInputElement>): void {
    const newEndPage = parseInt(event.target.value);
    if (newEndPage >= startPage && newEndPage <= totalPages) {
      onRowChanged(startPage, newEndPage, colourMode);
    } else {
      setInputEndPage(endPage);
    }
  }

  function handleColourChanged(event: ChangeEvent<HTMLSelectElement>): void {
    onRowChanged(startPage, endPage, event.target.value);
  }

  function updateInputEndValue(event: ChangeEvent<HTMLInputElement>): void {
    setInputEndPage(parseInt(event.target.value));
  }

  return (
    <tr>
      <th></th>
      <td className="value">
        <input
          type="number"
          className="RangeInput"
          value={startPage}
          disabled={true}
        />
        <input
          type="number"
          className="RangeInput"
          value={inputEndPage}
          min={startPage}
          max={totalPages}
          onBlur={handleEndChanged}
          onChange={updateInputEndValue}
        />

        <select
          id="cq-pod-colour-mode"
          className="RangeInput"
          onChange={handleColourChanged}
          value={colourMode}
        >
          <option value="black" className="attached enabled">
            Black
          </option>
          <option value="colour" className="attached enabled">
            Colour
          </option>
        </select>
      </td>
    </tr>
  );
}

export default MixModePagesRowSelector;
